<div class="item cn-up-down">
	<i class="icon audio-mes">
		<queue-ico></queue-ico>
		<span class="counter"><span>{{ node._id_ + 1 }}</span></span>
	</i>
	<div class="name">Очередь</div>
</div>